import {
  BreadcrumbPage,
  TabItem,
  ToastType,
  ToastVariation,
} from "./HostServiceContext";
import { useMemo, useState } from "react";
import { HostServiceContext } from "./HostServiceContext";

interface HostServiceProviderProps {
  children: React.ReactElement;
}

export function HostServiceProvider(props: HostServiceProviderProps) {
  const { children } = props;

  // Breadcrumbs
  const [breadcrumbs, setBreadcrumbs] = useState<
    BreadcrumbPage[] | undefined
  >();

  // Print Button
  const [showPrintButton, setShowPrintButton] = useState<boolean>(false);

  // Tabs
  const [tabs, setTabs] = useState<TabItem[] | undefined>();

  // Toasts
  const [toasts, setToasts] = useState<ToastType[]>([]);

  const addToast = (
    title: string,
    message: string,
    variation?: ToastVariation,
  ) => {
    const newToast = {
      variation: variation,
      title: title,
      message: message,
      id: Date.now(),
    };

    setToasts((previousToasts) => [...previousToasts, newToast]);
  };

  const removeToast = (id: number) => {
    setToasts((previousToasts) =>
      previousToasts.filter((toast) => toast.id !== id),
    );
  };

  // Memoized functions
  const contextFunctions = useMemo(
    () => ({
      setBreadcrumbs,
      setShowPrintButton,
      setTabs,
      addToast,
      removeToast,
    }),
    [],
  );

  return (
    <HostServiceContext.Provider
      value={{
        breadcrumbs,
        showPrintButton,
        tabs,
        toasts,
        ...contextFunctions,
      }}
    >
      {children}
    </HostServiceContext.Provider>
  );
}
